module.exports = __webpack_public_path__ + "static/logos-19-44b0fdacc4e85a91c36561b96d762a72.png";